

export const MarketStatus = ({ marketStatus }) => {
    
    return (
        <div className="market-status" style={{ color: marketStatus === 'Open' ? '#66FF00' : '#AAAAAA' }}>
        <p>{marketStatus === 'Open' ? 'MARKETS OPEN' : 'MARKETS CLOSED'}</p>
        <div style={{ display: "flex" }}>
            <img src={`/assets/svgs/signal${marketStatus === 'Open' ? 'On' : 'Off'}.svg`} alt="" />
        </div>
        <p>:</p>
    </div>
    );
}